import { HTTPClient } from '../utils/request'
import { HTTPClientTracking } from '../utils/request'

export default {
  // Total de Viagens
  availableOffers: ({ query }) =>
    HTTPClient.get(`dashboard/availableOffers${query}`),

  // Volume Total (Ton)
  totalOffersWeight: ({ query }) =>
    HTTPClient.get(`/dashboard/offerWeight${query}`),

  // Volume Disponível (Ton)
  availableOffersVolume: ({ query }) =>
    HTTPClient.get(`/dashboard/availableOffersVolume${query}`),

  // Ticket Médio (R$/Ton)
  averageTicket: ({ query }) =>
    HTTPClient.get(`dashboard/averageTicket${query}`),

  // Cargas D+2
  offerWaitingTwoDays: ({ query }) =>
    HTTPClient.get(`dashboard/offerWaitingTwoDays${query}`),

  // Novos Motoristas
  newDrivers: ({ query }) =>
    HTTPClient.get(`/dashboard/countingNewDrivers${query}`),

  // Total de Motoristas
  totalDrivers: ({ query }) =>
    HTTPClient.get(`dashboard/countingDrivers${query}`),

  // Idade Média Motoristas
  driverAverageAge: ({ query }) =>
    HTTPClient.get(`dashboard/driveAverageAge${query}`),

  // Total de Veículos
  countVehicles: ({ query }) =>
    HTTPClient.get(`dashboard/countVehicles${query}`),

  // Idade Média Veículos
  vehicleAverageAge: ({ query }) =>
    HTTPClient.get(`/dashboard/vehicleAverageAge${query}`),

  // Motoristas em pânico
  driversInPanic: () => HTTPClient.get(`/dashboard/driversInPanic`),

  // Mototistas online
  driverStatusRadar: () => HTTPClientTracking.get(`/geolocation`)
}
